/**
 * Static locale constants - no dependency on RMS data or derived types.
 * These are fixed values used across the app; derived constants live in locale-config.derived-constants.
 */

// =============================================================================
// CORE LOCALE CONSTANTS
// =============================================================================

/** Locale cookie name */
export const LOCALE_COOKIE = 'NEXT_PREFERRED_LOCALE'

/** Region details localStorage key */
export const REGION_DETAILS_LOCAL_STORAGE_KEY = 'REGION_DETAILS'

/** Locale format template (lowercase country) */
export const LOCALE_FORMAT = '{{language}}-{{country}}'

/** Locale format template for standard format (uppercase country) */
export const LOCALE_FORMAT_STANDARD = '{{language}}-{{countryUpper}}'

/** Default locale identifier (lowercase: en-us). Single source of truth for default locale. */
export const DEFAULT_LOCALE = 'en-us'

/** Default language (en-us format) */
export const DEFAULT_LANGUAGE = 'en-us' // TODO(sachin_i18n): get language from Next preferred cookie

/** Default locale prefix (en-us) */
export const DEFAULT_LOCALE_PREFIX = 'en-us'

/** Fallback region ID for US */
export const FALLBACK_REGION_ID = 101

export const DEFAULT_LANGUAGE_CODE = 'en'
